import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiFolder, FiFileText, FiChevronDown, FiChevronRight } from 'react-icons/fi';

export default function AccountingSidebar() {
  const location = useLocation();
  const [openSections, setOpenSections] = useState({
    binding: true,
    general: true,
    assets: true,
    financials: true
  });

  const isActive = (path) => {
    return location.pathname === path ? 'bg-[#b2ebf2] font-bold text-[#0000a0]' : 'text-gray-700 hover:bg-[#b2ebf2] hover:text-[#0000a0]';
  };

  const toggleSection = (section) => {
    setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  return (
    <div className="w-56 bg-[#e0f7fa] border-r border-teal-200 hidden md:flex flex-col flex-shrink-0">
      <div className="p-3 text-[14px] font-bold text-teal-900 border-b border-teal-200 bg-[#a6e4e7]">
        Accounting
      </div>
      <div className="flex-1 overflow-y-auto py-2">
        
        {/* Section 1: Binding & Income */}
        <div className="mb-1">
          <div className="flex items-center px-3 py-1.5 text-[13px] font-bold text-gray-800 cursor-pointer hover:bg-teal-100 transition-colors select-none" onClick={() => toggleSection('binding')}>
            {openSections.binding ? <FiChevronDown className="mr-1 text-gray-500" /> : <FiChevronRight className="mr-1 text-gray-500" />}
            <FiFolder className="mr-1.5 text-yellow-500 fill-current" /> Invoice binding
          </div>
          {openSections.binding && (
            <ul className="text-[13px] pl-8 space-y-0.5 mt-0.5">
              <li>
                <Link to="/accounting/bind" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/bind')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Binding
                </Link>
              </li>
              <li>
                <Link to="/accounting/general" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/general')}`}>
                  <FiFolder className="mr-2 text-yellow-500 fill-current opacity-80" /> Accounting
                </Link>
              </li>
              <li>
                <Link to="/accounting/income" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/income')}`}>
                  <FiFolder className="mr-2 text-yellow-500 fill-current opacity-80" /> Income
                </Link>
              </li>
              <li>
                <Link to="/accounting/sales-cos" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/sales-cos')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Sales - COS
                </Link>
              </li>
              <li>
                <Link to="/accounting/product-income" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/product-income')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Product Income
                </Link>
              </li>
              <li>
                <Link to="/sales/records" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/sales/records')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Sale
                </Link>
              </li>
            </ul>
          )}
        </div>

        <div className="my-2 border-t border-teal-200 mx-2"></div>

        {/* Section 2: General */}
        <div className="mb-1">
          <div className="flex items-center px-3 py-1.5 text-[13px] font-bold text-gray-800 cursor-pointer hover:bg-teal-100 transition-colors select-none" onClick={() => toggleSection('general')}>
            {openSections.general ? <FiChevronDown className="mr-1 text-gray-500" /> : <FiChevronRight className="mr-1 text-gray-500" />}
            <FiFolder className="mr-1.5 text-yellow-500 fill-current" /> General
          </div>
          {openSections.general && (
            <ul className="text-[13px] pl-8 space-y-0.5 mt-0.5">
              <li>
                <Link to="/accounting/accounting-income" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/accounting-income')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Accounting income
                </Link>
              </li>
              <li>
                <Link to="/accounting/comprehensive-income" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/comprehensive-income')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Comprehensive income
                </Link>
              </li>
            </ul>
          )}
        </div>

        <div className="my-2 border-t border-teal-200 mx-2"></div>

        {/* Section 3: Total of assets */}
        <div className="mb-1">
          <div className="flex items-center px-3 py-1.5 text-[13px] font-bold text-gray-800 cursor-pointer hover:bg-teal-100 transition-colors select-none" onClick={() => toggleSection('assets')}>
            {openSections.assets ? <FiChevronDown className="mr-1 text-gray-500" /> : <FiChevronRight className="mr-1 text-gray-500" />}
            <FiFolder className="mr-1.5 text-yellow-500 fill-current" /> Total of assets
          </div>
          {openSections.assets && (
            <ul className="text-[13px] pl-8 space-y-0.5 mt-0.5">
              <li>
                <Link to="/accounting/sale-2" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/sale-2')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Sale
                </Link>
              </li>
              <li>
                <Link to="/accounting/income-2" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/income-2')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Income
                </Link>
              </li>
              <li>
                <Link to="/accounting/base-income" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/base-income')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Base Income
                </Link>
              </li>
            </ul>
          )}
        </div>

        <div className="my-2 border-t border-teal-200 mx-2"></div>

        {/* Section 4: Financials */}
        <div className="mb-1">
          <div className="flex items-center px-3 py-1.5 text-[13px] font-bold text-gray-800 cursor-pointer hover:bg-teal-100 transition-colors select-none" onClick={() => toggleSection('financials')}>
            {openSections.financials ? <FiChevronDown className="mr-1 text-gray-500" /> : <FiChevronRight className="mr-1 text-gray-500" />}
            <FiFolder className="mr-1.5 text-yellow-500 fill-current" /> Core Accounting
          </div>
          {openSections.financials && (
            <ul className="text-[13px] pl-8 space-y-0.5 mt-0.5">
              <li>
                <Link to="/accounting/chart-of-accounts" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/chart-of-accounts')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Chart of Accounts
                </Link>
              </li>
              <li>
                <Link to="/accounting/journals" className={`flex items-center py-1.5 px-2 rounded-l-md transition-colors ${isActive('/accounting/journals')}`}>
                  <FiFileText className="mr-2 opacity-60 text-teal-800" /> Journals
                </Link>
              </li>
            </ul>
          )}
        </div>

      </div>
    </div>
  );
}